import React, { useEffect } from "react";
import { connect }  from "react-redux";
import { FormattedMessage } from "react-intl";

// @mui/material components
import { Dialog, DialogTitle, DialogContent } from "@mui/material";

// core components
import Form from './form';

function CreateDialog(props) {
    const { gender, closeDialog, created, isOpen, isSubGender, position, allGenders } = props;

    useEffect(() => {
        if (created) {
            closeDialog();
        }
    }, [created]);

    return (
        <Dialog
            open={isOpen}
            onClose={closeDialog}
            maxWidth={'sm'}
            scroll={'body'}
        >
            <DialogTitle>
                <FormattedMessage id={isSubGender ? "gender.form.sub.create.title" : "gender.form.create.title"} />
            </DialogTitle>
            <DialogContent>
                <Form
                    closeDialog={closeDialog}
                    gender={isSubGender && gender}
                    isSubGender={isSubGender}
                    allGenders={allGenders}
                    position={position}
                />
            </DialogContent>
        </Dialog>
    )
}

const mapStateToProps = state => {
    return {
        created: state.gender.create.created,
    }
};

export default connect(
    mapStateToProps,
    null,
)(CreateDialog);
